import { MarketplaceIncentive } from '@carvana/merch-contracts';
import { VehiclePrice } from '@carvana/merch-contracts';
import resolveIncentives from './resolveIncentives';

export type NormalizedIncentives = {
  additionalIncentives?: {
    amount: number;
    incentives: MarketplaceIncentive[];
  };
  appliedIncentives?: {
    amount: number;
    incentives: MarketplaceIncentive[];
  };
  maxIncentivesAmount?: number;
};

export default function normalizeIncentives(
  price: Partial<VehiclePrice> | undefined
): NormalizedIncentives {
  if (!price || !price.maxIncentivesAmount) return {};

  const {
    additionalIncentives = [],
    appliedIncentives = [],
    appliedIncentivesAmount,
    marketplaceIncentives = [],
    additionalIncentivesAmount,
    maxIncentivesAmount
  } = price;

  return {
    additionalIncentives: additionalIncentivesAmount
      ? {
          amount: additionalIncentivesAmount,
          incentives: resolveIncentives(
            additionalIncentives,
            marketplaceIncentives
          )
        }
      : undefined,
    appliedIncentives: appliedIncentivesAmount
      ? {
          amount: appliedIncentivesAmount,
          incentives: resolveIncentives(
            appliedIncentives,
            marketplaceIncentives
          )
        }
      : undefined,
    maxIncentivesAmount
  };
}
